module.exports = __webpack_public_path__ + "img/riviera-logo.832fa7c6.jpg";